import { usePartnerMissionStore } from "../../../../stores/Cac/Partner/partnerMission";
import SelectManager from "../Utils/SelectManager";
import { useUtilsStore } from "../../../../stores/Utils/selects";
import SelectServiceMission from "../Utils/SelectServiceMission";
import SelectYear from "../Utils/SelectYear";
import SelectDate from "../Utils/SelectDate";
import { useEffect, useState } from "react";
import {
  createMission,
  createUserCustomer,
  downloadMissionLetter,
  getMissionDataByCustomer,
  getPartnerAssociated,
  getUserCustomer,
  getUsersCustomerToMission,
  getUsersPartnerToMission,
  postMissionFile,
  updateMission,
} from "../../../../services/Api/customerService";
import {
  showToastError,
  showToastSuccess,
} from "../../../../services/Toasts/toasts";
import UploadMission from "../Utils/UploadMissionLetter";
import {
  dateFormat,
  verifyEmail,
} from "../../../../services/Utils/functionService";
import { IUserManagerMission } from "../../../../interfaces/user";
import { useParams } from "react-router-dom";
import { useTokenContext } from "../../../../context/tokenContext";
import SelectPeriodMission from "../Utils/SelectPeriodMission";
import SelectMonth from "../Utils/SelectMonth";
import download from "../../../../assets/icons/download.svg";
import { useServiceStore } from "../../../../stores/admin/service";
import SearchBar from "../../../Admin/Services/SearchBar";
import { getRelaunchs } from "../../../../services/Api/partnerService";

const PartnerModalCreateUpdateMission = () => {
  // Store
  const {
    choiceModal,
    setChoiceModal,
    usersClients,
    setUsersClients,
    collabsAssignedToClient,
    setCollabsAssignedToClient,
    checkboxValuesCollabs,
    setCheckboxValuesCollabs,
    checkboxValuesClients,
    setCheckboxValuesClients,
    checkboxRelaunchAuto,
    setCheckboxRelaunchAuto,
    dataMission,
    setDataMission,
    newUser,
    setNewUser,
    createNewClient,
    setCreateNewClient,
    resetNewUser,
    resetMission,
    missionId,
    missionDetails,
    setMissionDetails,
    idRelaunchAuto,
    setIdRelaunchAuto,
    setErrorLimitMission,
  } = usePartnerMissionStore();
  const { idCustomer, idPartner } = useParams();
  const { searchTerm } = useServiceStore();
  const { userId } = useTokenContext();
  const {
    resetSelects,
    selectedManager,
    setSelectedManager,
    isRenewable,
    setIsRenewable,
  } = useUtilsStore();
  const [relaunchs, setRelaunchs] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleResetAll = () => {
    resetMission();
    resetSelects();
    setChoiceModal("");
    setCheckboxValuesClients({});
    setCheckboxValuesCollabs({});
    setIsRenewable(false);
  };

  // Function to get collaborateurs assign to a client
  useEffect(() => {
    if (idCustomer)
      setDataMission({
        ...dataMission,
        idCustomer: Number(idCustomer),
      });
    // This is for collabs
    getPartnerAssociated(Number(idCustomer))
      .then((data) => {
        // Supprimer le manager de la liste
        const filteredData = data.filter(
          (collab: any) => collab.id !== selectedManager,
        );

        const mappedData: { [key: number]: IUserManagerMission } = {};

        filteredData.forEach((assignUser: IUserManagerMission) => {
          mappedData[assignUser.id] = assignUser;
        });
        if (choiceModal === "create") {
          const checkboxValues: { [key: number]: boolean } = {};
          Object.values(mappedData).forEach(
            (assignUser: IUserManagerMission) => {
              if (assignUser.id === userId) {
                checkboxValues[assignUser.id] = true;
              } else {
                checkboxValues[assignUser.id] = false;
              }
            },
          );

          setCollabsAssignedToClient(Object.values(mappedData));
          setCheckboxValuesCollabs(checkboxValues);
        } else {
          // UPDATE MISSION
          if (idCustomer)
            getUsersPartnerToMission(Number(idCustomer), missionId)
              .then((res) => {
                // Si pas de collaborateurs assignés
                if (res.status === 204) {
                  setCollabsAssignedToClient(Object.values(mappedData));
                } else {
                  const checkboxValues: { [key: number]: boolean } = {};

                  Object.values(mappedData).forEach((assignUser: any) => {
                    checkboxValues[assignUser.id] = res.data.some(
                      (user: any) => user.id === assignUser.id,
                    );
                  });
                  setCollabsAssignedToClient(Object.values(mappedData));
                  setCheckboxValuesCollabs(checkboxValues);
                }
              })
              .catch(() => showToastError("Une erreur s'est produite"));
        }
      })
      .catch(() => showToastError("Une erreur s'est produite"));

    if (choiceModal === "update") {
      getMissionDataByCustomer(Number(idCustomer), Number(missionId))
        .then((data) => {
          setMissionDetails(data);
          setDataMission(data);
          setIdRelaunchAuto(data.idRemindType);
          setSelectedManager(data.managerId);
          if (data.autoRemind === true) {
            setCheckboxRelaunchAuto(true);
          } else {
            setCheckboxRelaunchAuto(false);
          }
        })
        .catch(() => showToastError("Une erreur s'est produite"));
    }
  }, [idCustomer, choiceModal]);

  useEffect(() => {
    if (searchTerm !== "") {
      const filteredData = collabsAssignedToClient?.filter(
        (collab: any) =>
          collab?.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          collab?.lastName.toLowerCase().includes(searchTerm.toLowerCase()),
      );
      setCollabsAssignedToClient(filteredData);
    } else {
      getPartnerAssociated(Number(idCustomer))
        .then((data) => {
          setCollabsAssignedToClient(data);
        })
        .catch(() => showToastError("Une erreur s'est produite"));
    }
  }, [searchTerm]);

  useEffect(() => {
    if (checkboxRelaunchAuto) {
      getRelaunchs(Number(idPartner))
        .then((res) => {
          const formatedData = res.data.map((item: any) => ({
            value: item.id,
            label: item.title + " (" + item.amountOfDays + " jours)",
          }));
          setRelaunchs(formatedData);
        })
        .catch(() => showToastError("Une erreur s'est produite"));
    }
  }, [checkboxRelaunchAuto]);

  useEffect(() => {
    // This is for clients
    getUserCustomer(idCustomer)
      .then((users) => {
        setUsersClients(users);
        const clientCheckboxValues: { [key: number]: boolean } = {};
        users.forEach((user: any) => {
          clientCheckboxValues[user.id] = false;
        });
        setCheckboxValuesClients(clientCheckboxValues);

        // UPDATE
        if (choiceModal === "update") {
          getUsersCustomerToMission(Number(idCustomer), missionId)
            .then((assignedUsers) => {
              const clientCheckboxValues: { [key: number]: boolean } = {};
              // Enrichir les utilisateurs avec la date de dernière consultation
              const enrichedUsers = users?.map((user: any) => {
                // Vérifier si l'utilisateur est assigné à la mission
                const assignedUser = assignedUsers?.find(
                  (assigned: any) => assigned.id === user.id,
                );
                clientCheckboxValues[user.id] = !!assignedUser;
                return {
                  ...user,
                  lastConsultationDate:
                    assignedUser?.lastConsultationDate ?? null,
                };
              });

              setUsersClients(enrichedUsers);
              setCheckboxValuesClients(clientCheckboxValues);
            })
            .catch(() => console.log("Une erreur s'est produite"));
        }
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  }, [idCustomer, choiceModal, createNewClient]);

  // Fonction pour gérer le changement des collaborateurs affectés
  const handleCheckboxChangeCollabs = (value: number, checked: boolean) => {
    setCheckboxValuesCollabs({ ...checkboxValuesCollabs, [value]: checked });
  };

  // Fonction pour gérer le changement des clients affectés
  const handleCheckboxChangeClients = (value: number, checked: boolean) => {
    setCheckboxValuesClients({ ...checkboxValuesClients, [value]: checked });
  };

  // Fonction pour créer ou mettre à jour une mission
  const handleCreateOrUpdateMission = async () => {
    if (dataMission.dueDate === null && !isRenewable) {
      showToastError("Veuillez renseigner une date de fin de mission");
      return;
    } else if (dataMission.dateExercice === null) {
      showToastError("Veuillez renseigner une date d'exercice");
      return;
    } else if (dataMission.categoryId === 0) {
      showToastError("Veuillez renseigner une catégorie de mission");
      return;
    } else if (dataMission.managerId === 0) {
      showToastError("Veuillez sélectionner un responsable");
      return;
    }
    try {
      if (idCustomer !== "0") {
        let dataForSend;
        if (!isRenewable) {
          dataForSend = {
            categoryId: dataMission.categoryId,
            dateExercice: dataMission.dateExercice,
            managerId: dataMission.managerId,
            autoRemind: checkboxRelaunchAuto,
            dueDate: dataMission.dueDate,
            idRemindType: idRelaunchAuto,
            partnerUsers: Object.entries(checkboxValuesCollabs)
              .filter(([_, value]) => value)
              .map(([key]) => Number(key)),
            existingCustomerUsers: Object.entries(checkboxValuesClients)
              .filter(([_, value]) => value)
              .map(([key]) => Number(key)),
          };
        } else {
          const startMonth: any = dataMission.startMonth;
          const parsedStartMonth = new Date(startMonth);
          const dueDate = new Date(parsedStartMonth);

          dueDate.setFullYear(dueDate.getFullYear() + 1);

          dataForSend = {
            categoryId: dataMission.categoryId,
            dateExercice: dataMission.dateExercice,
            managerId: dataMission.managerId,
            autoRemind: checkboxRelaunchAuto,
            idRemindType: idRelaunchAuto,
            dueDate: dueDate,
            partnerUsers: Object.entries(checkboxValuesCollabs)
              .filter(([_, value]) => value)
              .map(([key]) => Number(key)),
            existingCustomerUsers: Object.entries(checkboxValuesClients)
              .filter(([_, value]) => value)
              .map(([key]) => Number(key)),
            startMonth: dataMission.startMonth,
            periodType: dataMission.periodType,
          };
        }

        let missionResponse;
        let idMission;
        if (choiceModal === "update") {
          missionResponse = await updateMission(
            Number(idCustomer),
            missionId,
            dataForSend,
          );
        } else {
          // Création de la mission avec les utilisateurs assignés
          missionResponse = await createMission(idCustomer, dataForSend);

          if (missionResponse) {
            idMission = Number(missionResponse.id);
            if (dataMission.file !== null) {
              // Envoi du fichier de mission
              await postMissionFile(
                Number(idCustomer),
                dataMission.file,
                Number(idMission),
              );
            }
          }
        }

        if (missionResponse) {
          handleResetAll();
          choiceModal === "create"
            ? showToastSuccess("La mission a bien été créée !")
            : showToastSuccess("La mission a bien été modifié !");
        } else {
          showToastError("Une erreur est survenue");
        }
      }
    } catch (error) {
      handleResetAll();
      if (typeof error === "object" && error !== null && "response" in error) {
        const typedError = error as { response: { data: { message: string } } };
        if (
          typedError.response.data.message &&
          typeof typedError.response.data.message === "string" &&
          typedError.response.data.message.trim() ===
            "Vous avez atteint votre quota de mission active, ou bien votre abonnement est arrivé a expiration, merci de vous rapprochez du service commercial"
        ) {
          setErrorLimitMission(true);
        } else {
          showToastError("Une erreur est survenue");
        }
      } else {
        showToastError("Une erreur est survenue");
      }
    }
  };

  const handleCreateUser = () => {
    setIsLoading(true);
    if (!verifyEmail(newUser.eMail)) {
      showToastError("Veuillez renseigner un email valide");
      return;
    }
    createUserCustomer(idCustomer, newUser)
      .then(() => {
        setIsLoading(false);
        setCreateNewClient(!createNewClient);
        showToastSuccess("L'utilisateur a bien été créé !");
        resetNewUser();
      })
      .catch((err) => {
        setIsLoading(false);
        // Vérifier que err.response existe
        if (err?.response) {
          // Vérifier le status code 403
          if (err.response.status === 403) {
            // Vérifier si un message existe dans la réponse
            if (
              err.response?.data?.message ===
              "User is already a partner for this partner"
            ) {
              showToastError(
                "Vous ne pouvez affecter un collaborateur en tant que client",
              );
              return;
            } else {
              showToastError(
                "Vous ne pouvez affecter un collaborateur en tant que client",
              );
              return;
            }
          }
          // Vérifier si un message d'erreur existe pour d'autres cas
          if (err.response?.data?.message) {
            if (
              err.response.data.message ===
              "User is already a partner for this partner"
            ) {
              showToastError(
                "Vous ne pouvez affecter un collaborateur en tant que client",
              );
              return;
            }
          }
        }
        // Message d'erreur par défaut
        showToastError("Une erreur est survenue");
      });
  };

  const handleUserChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    field: string,
  ) => {
    const value = event.target.value;
    let updatedUsers = { ...newUser };
    updatedUsers = { ...updatedUsers, [field]: value };
    setNewUser(updatedUsers);
  };

  const handleDownload = () => {
    downloadMissionLetter(Number(idCustomer), Number(missionId))
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${missionDetails?.name}.pdf`);
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  };

  return (
    choiceModal !== "" && (
      <>
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden p-2 font-BarlowCondensed outline-hidden focus:outline-hidden sm:p-5">
          <div className="relative m-auto w-full max-w-5xl">
            {/*content*/}
            <div className="relative flex max-h-[calc(100dvh-1rem)] w-full flex-col overflow-hidden rounded-2xl border-0 bg-gradient-to-br from-slate-50 to-blue-50 shadow-2xl outline-hidden focus:outline-hidden sm:max-h-[90dvh]">
              {/*body*/}
              <div className="flex min-h-0 w-full flex-col items-center justify-start overflow-y-auto p-2 sm:p-3">
                {/* Part for create a mission */}
                {choiceModal === "create" ? (
                  <div className="w-full bg-white rounded-2xl shadow-lg border border-gray-100 p-3 mb-3">
                    <h4 className="text-base font-semibold text-gray-700 mb-3 flex items-center gap-2">
                      <svg
                        className="w-4 h-4 text-yellow-trio"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                      </svg>
                      Configuration de la mission
                    </h4>
                    <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                      <SelectManager />
                      <SelectServiceMission />
                      <SelectYear />
                      {!isRenewable ? <SelectDate /> : <SelectPeriodMission />}
                    </div>
                    {isRenewable && (
                      <div className="mt-3 p-3 bg-blue-50 rounded-xl border border-blue-200">
                        <div className="flex items-center gap-2 mb-2">
                          <svg
                            className="w-4 h-4 text-blue-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                            />
                          </svg>
                          <span className="font-medium text-blue-800 text-sm">
                            Mission renouvelable
                          </span>
                        </div>
                        <div className="flex items-center gap-3">
                          <p className="text-blue-700 text-sm">
                            Date de début :
                          </p>
                          <SelectMonth />
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="w-full bg-white rounded-2xl shadow-lg border border-gray-100 p-3 mb-3">
                    <h4 className="text-base font-semibold text-gray-700 mb-3 flex items-center gap-2">
                      <svg
                        className="w-4 h-4 text-yellow-trio"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.586a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      </svg>
                      Paramètres de la mission
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <SelectManager />
                      {missionDetails?.isThereALetter && (
                        <div className="flex items-center gap-2 p-2 bg-green-50 rounded-xl border border-green-200">
                          <svg
                            className="w-4 h-4 text-green-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                            />
                          </svg>
                          <div>
                            <p className="font-medium text-green-800 text-sm">
                              Lettre de mission
                            </p>
                            <button
                              onClick={() => handleDownload()}
                              className="text-green-600 hover:text-green-800 text-xs flex items-center gap-1 mt-1"
                            >
                              <img
                                src={download}
                                alt="télécharger"
                                className="w-3 h-3"
                              />
                              Télécharger
                            </button>
                          </div>
                        </div>
                      )}

                      {/* Relance automatique */}
                      <div className="w-full bg-blue-50 rounded-xl border border-blue-200 p-4">
                        <div className="flex w-full flex-col items-start gap-3 sm:flex-row sm:gap-4">
                          {/* Icône et titre */}
                          <div className="flex items-center gap-3 flex-shrink-0">
                            <svg
                              className="w-5 h-5 text-blue-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                            <p className="font-medium text-blue-800 text-sm whitespace-nowrap">
                              Relance automatique
                            </p>
                          </div>

                          {/* Toggle switch */}
                          <div className="flex items-center">
                            <div className="relative inline-block w-10 align-middle select-none transition duration-200 ease-in">
                              <input
                                type="checkbox"
                                name="toggle"
                                id="toggle"
                                className="toggle-checkbox absolute block w-5 h-5 rounded-full bg-white border-4 appearance-none cursor-pointer transition-all duration-200 ease-in"
                                checked={checkboxRelaunchAuto}
                                onChange={() => {
                                  setCheckboxRelaunchAuto(
                                    !checkboxRelaunchAuto,
                                  );
                                }}
                              />
                              <label
                                className={`toggle-label block overflow-hidden h-5 rounded-full cursor-pointer transition-all duration-200 ease-in ${checkboxRelaunchAuto ? "bg-blue-500" : "bg-gray-300"}`}
                              ></label>
                            </div>
                          </div>

                          {/* Sélecteur de type de relance */}
                          {checkboxRelaunchAuto && (
                            <div className="flex-1 min-w-0">
                              <p className="font-medium text-blue-800 text-sm mb-2">
                                Type de relance
                              </p>
                              <select
                                className="w-full px-3 py-2 border border-gray-300 bg-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-150 text-sm"
                                value={idRelaunchAuto || ""}
                                onChange={(e) =>
                                  setIdRelaunchAuto(Number(e.target.value))
                                }
                              >
                                <option value="">
                                  Sélectionner un type de relance
                                </option>
                                {relaunchs.map((relaunch) => (
                                  <option
                                    key={relaunch.value}
                                    value={relaunch.value}
                                  >
                                    {relaunch.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Part for collabs and clients */}
                <div className="w-full bg-white rounded-2xl shadow-lg border border-gray-100 p-3 mb-3">
                  <h4 className="text-base font-semibold text-gray-700 mb-3 flex items-center gap-2">
                    <svg
                      className="w-4 h-4 text-yellow-trio"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                      />
                    </svg>
                    Gestion des utilisateurs
                  </h4>

                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                    {/* Collaborateurs affectés */}
                    <div className="bg-gray-50 rounded-xl p-3 border border-gray-200">
                      <div className="flex items-center gap-2 mb-2">
                        <div className="p-1.5 bg-blue-100 rounded-lg">
                          <svg
                            className="w-3.5 h-3.5 text-blue-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            />
                          </svg>
                        </div>
                        <h5 className="font-semibold text-gray-700 text-sm">
                          Collaborateurs affectés
                        </h5>
                      </div>
                      <SearchBar />
                      <div className="w-full bg-white border border-gray-200 rounded-lg m-auto h-32 overflow-y-auto shadow-sm mt-2">
                        {collabsAssignedToClient?.map((user) => (
                          <div
                            key={user?.id}
                            className="flex items-center p-2 border-b border-gray-100 hover:bg-blue-50 transition-colors duration-150"
                          >
                            <input
                              type="checkbox"
                              checked={checkboxValuesCollabs[user?.id] || false}
                              onChange={() => {
                                handleCheckboxChangeCollabs(
                                  user?.id,
                                  !checkboxValuesCollabs[user?.id],
                                );
                              }}
                              className="mr-2 w-3.5 h-3.5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                            />
                            <label className="text-md text-gray-700 cursor-pointer">
                              {user?.firstName === ""
                                ? user?.eMail
                                : `${user?.firstName} ${user?.lastName}`}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Création client */}
                    <div className="bg-gray-50 rounded-xl p-3 border border-gray-200">
                      <div className="flex items-center gap-2 mb-2">
                        <div className="p-1.5 bg-green-100 rounded-lg">
                          <svg
                            className="w-3.5 h-3.5 text-green-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                            />
                          </svg>
                        </div>
                        <h5 className="font-semibold text-gray-700 text-sm">
                          Création client
                        </h5>
                      </div>

                      <div className="w-full bg-white border border-gray-200 rounded-lg p-3 h-32 flex flex-col justify-between">
                        <div className="flex flex-col gap-2">
                          <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1">
                              Email
                            </label>
                            <input
                              type="email"
                              className="w-full px-2 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-150 text-sm"
                              minLength={10}
                              maxLength={200}
                              value={newUser.eMail}
                              placeholder="exemple@email.com"
                              onChange={(e) => handleUserChange(e, "eMail")}
                              required
                            />
                          </div>
                        </div>
                        <button
                          onClick={() => handleCreateUser()}
                          disabled={isLoading}
                          className="w-full bg-green-600 hover:bg-green-700 cursor-pointer text-white font-medium rounded-lg px-3 py-1.5 text-xs transition-colors duration-150 flex items-center justify-center gap-1"
                        >
                          <svg
                            className="w-3 h-3"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                            />
                          </svg>
                          {isLoading ? "Ajout..." : "Ajouter"}
                        </button>
                      </div>
                    </div>

                    {/* Clients affectés */}
                    <div className="bg-gray-50 rounded-xl p-3 border border-gray-200">
                      <div className="flex items-center gap-2 mb-2">
                        <div className="p-1.5 bg-purple-100 rounded-lg">
                          <svg
                            className="w-3.5 h-3.5 text-purple-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                            />
                          </svg>
                        </div>
                        <h5 className="font-semibold text-gray-700 text-sm">
                          Clients affectés
                        </h5>
                      </div>

                      <div className="w-full bg-white border border-gray-200 rounded-lg h-44 overflow-y-auto shadow-sm">
                        {usersClients.length > 0 &&
                          usersClients?.map((user) => (
                            <div
                              key={user?.id}
                              className="flex items-center p-2 border-b border-gray-100 hover:bg-purple-50 transition-colors duration-150"
                            >
                              <input
                                type="checkbox"
                                checked={
                                  checkboxValuesClients[user?.id] || false
                                }
                                onChange={() => {
                                  handleCheckboxChangeClients(
                                    user?.id,
                                    !checkboxValuesClients[user?.id],
                                  );
                                }}
                                className="mr-2 w-3.5 h-3.5 text-purple-600 bg-gray-100 border-gray-300 rounded focus:ring-purple-500 focus:ring-2"
                              />
                              {/* Compte non créé en create */}
                              {user.lastConnection === null &&
                              choiceModal === "create" ? (
                                <div className="flex flex-col">
                                  <span className="text-xs font-medium text-gray-700">
                                    {user.eMail}
                                  </span>
                                  <span className="text-xs text-gray-500 italic">
                                    Compte non créé
                                  </span>
                                </div>
                              ) : user.lastConnection !== null &&
                                choiceModal === "create" ? (
                                <div className="flex flex-col">
                                  <span className="text-xs font-medium text-gray-700">
                                    {user.firstName} {user.lastName}
                                  </span>
                                  <span className="text-xs text-gray-500">
                                    Connecté le{" "}
                                    {dateFormat(user?.lastConnection)}
                                  </span>
                                </div>
                              ) : null}

                              {/* Mission non consultée en update */}
                              {user.lastConsultationDate === null && usersClients.length > 0 &&
                              choiceModal === "update" ? (
                                <div className="flex flex-col">
                                  <span className="text-xs font-medium text-gray-700">
                                    {user.eMail}
                                  </span>
                                  <span className="text-xs text-gray-500 italic">
                                    Mission non consultée
                                  </span>
                                </div>
                              ) : user.lastConsultationDate !== null && usersClients.length > 0 &&
                                choiceModal === "update" ? (
                                <div className="flex flex-col">
                                  <span className="text-xs font-medium text-gray-700">
                                    {user.firstName} {user.lastName}
                                  </span>
                                  <span className="text-xs text-gray-500">
                                    Consultée le{" "}
                                    {dateFormat(user?.lastConsultationDate)}
                                  </span>
                                </div>
                              ) : null}
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>

                {choiceModal === "create" && (
                  <div className="flex w-full flex-col items-start justify-start gap-3 rounded-2xl border border-gray-100 bg-white p-3 shadow-lg lg:flex-row">
                    <div className="flex w-full flex-col items-start justify-start gap-3 lg:w-1/2">
                      <h4 className="text-base font-semibold text-gray-700 mb-3 flex items-center gap-2">
                        <svg
                          className="w-4 h-4 text-yellow-trio"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                          />
                        </svg>
                        Documents de mission
                      </h4>
                      <UploadMission />
                    </div>
                    {/* Relance automatique */}
                    <div className="w-full rounded-xl border border-blue-200 bg-blue-50 p-3 sm:p-4 lg:w-1/2">
                      <div className="flex w-full flex-col items-start gap-3 sm:flex-row sm:gap-4">
                        {/* Icône et titre */}
                        <div className="flex items-center gap-3 flex-shrink-0">
                          <svg
                            className="w-5 h-5 text-blue-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                          <p className="font-medium text-blue-800 text-sm whitespace-nowrap">
                            Relance automatique
                          </p>
                        </div>

                        {/* Toggle switch */}
                        <div className="flex items-center">
                          <div className="relative inline-block w-10 align-middle select-none transition duration-200 ease-in">
                            <input
                              type="checkbox"
                              name="toggle"
                              id="toggle"
                              className="toggle-checkbox absolute block w-5 h-5 rounded-full bg-white border-4 appearance-none cursor-pointer transition-all duration-200 ease-in"
                              checked={checkboxRelaunchAuto}
                              onChange={() => {
                                setCheckboxRelaunchAuto(!checkboxRelaunchAuto);
                              }}
                            />
                            <label
                              className={`toggle-label block overflow-hidden h-5 rounded-full cursor-pointer transition-all duration-200 ease-in ${checkboxRelaunchAuto ? "bg-blue-500" : "bg-gray-300"}`}
                            ></label>
                          </div>
                        </div>

                        {/* Sélecteur de type de relance */}
                        {checkboxRelaunchAuto && (
                          <div className="flex-1 min-w-0">
                            <p className="font-medium text-blue-800 text-sm mb-2">
                              Type de relance
                            </p>
                            <select
                              className="w-full px-3 py-2 border border-gray-300 bg-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-150 text-sm"
                              value={idRelaunchAuto || ""}
                              onChange={(e) =>
                                setIdRelaunchAuto(Number(e.target.value))
                              }
                            >
                              <option value="">
                                Sélectionner un type de relance
                              </option>
                              {relaunchs.map((relaunch) => (
                                <option
                                  key={relaunch.value}
                                  value={relaunch.value}
                                >
                                  {relaunch.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/*footer*/}
              <div className="flex flex-shrink-0 items-center justify-end gap-3 rounded-b-2xl border-t border-solid border-gray-200 bg-white p-3">
                <button
                  className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-gray-100 px-4 py-2 text-sm font-semibold text-gray-500 transition-all duration-200 hover:bg-red-500 hover:text-white sm:flex-none"
                  type="button"
                  onClick={() => handleResetAll()}
                >
                  <svg
                    className="w-3.5 h-3.5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                  Annuler
                </button>
                {choiceModal === "create" ? (
                  <button
                    className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-lg transition-all duration-200 hover:bg-green-700 hover:shadow-xl sm:flex-none sm:hover:scale-105"
                    type="button"
                    onClick={handleCreateOrUpdateMission}
                  >
                    <svg
                      className="w-3.5 h-3.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      />
                    </svg>
                    Créer la mission
                  </button>
                ) : (
                  <button
                    className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-lg transition-all duration-200 hover:bg-green-700 hover:shadow-xl sm:flex-none sm:hover:scale-105"
                    type="button"
                    onClick={handleCreateOrUpdateMission}
                  >
                    <svg
                      className="w-3.5 h-3.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.586a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    </svg>
                    Modifier la mission
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    )
  );
};

export default PartnerModalCreateUpdateMission;
